<template>
  <div class="org-flexipass">
    <div class="d-flex align-items-start justify-content-between flex-wrap mb-1" style="gap: 12px">
      <div>
        <h4 class="mb-25"><i class="fas fa-mobile-alt mr-50"/>{{ msg('Flexipass account') }}</h4>
        <p class="text-muted mb-0" style="max-width: 62ch">
          {{ msg('One Flexipass login for the whole organization. Each building additionally gets its own API token — set it on the building itself, together with which door flows are offered.') }}
        </p>
      </div>
    </div>

    <b-row>
      <b-col cols="12" lg="4">
        <b-form-group :label="msg('Flexipass username')" label-for="org-flexipassUsername">
          <b-form-input id="org-flexipassUsername" v-model="org.flexipassUsername"
                        autocomplete="off" spellcheck="false"/>
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="4">
        <b-form-group :label="msg('Flexipass password')" label-for="org-flexipassPassword">
          <b-input-group>
            <b-form-input id="org-flexipassPassword" v-model="org.flexipassPassword"
                          :type="revealed ? 'text' : 'password'" autocomplete="off" spellcheck="false"/>
            <b-input-group-append>
              <b-button variant="outline-secondary" :title="revealed ? msg('Hide') : msg('Show')"
                        @click="revealed = !revealed">
                <feather-icon :icon="revealed ? 'EyeOffIcon' : 'EyeIcon'"/>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="d-flex align-items-center justify-content-between flex-wrap mt-1">
      <small class="text-muted">
        <i class="fas fa-shield-alt mr-25"/>{{ msg('The password never leaves the server session and is not sent to guests') }}
      </small>
      <b-button variant="primary" @click="$emit('save')">{{ msg('save') }}</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orgFlexipass',
  props: { value: Object },
  data() {
    return { revealed: false }
  },
  computed: {
    org: {
      get() {
        if (this.value == null) {
          console.error('orgFlexipass: value (v-model) is null!')
          return {}
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
</style>
